import type { StepConfig } from "@portal/components/multiform/types";
import type { CombinedFormData } from "../../schema";
import { BondStep } from "./BondStep";
import { BondSummary } from "./BondSummary";

export const bondStepConfig: StepConfig<CombinedFormData> = {
	name: "bond",
	label: "Bond",
	fieldPaths: ["quote", "bondType", "contractBondType", "commercialBond"],
	component: BondStep,
	summaryComponent: BondSummary,
};
